export const TIRE_SIZES = 'tireSizes'
export const VEHICLE_DETAILS = 'vehicleDetails'
export const EXTRA_VEHICLE_DETAILS = 'extraVehicleDetails'
